exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".event .cta{font-weight:700}.event .serie{font-size:100%}.event .body-long{font-size:80%}", ""]);

// exports
